import type { HistoryPerson, LeagueHistory } from "@averagejoesff/shared";
import { AppLink } from "../../components/AppLink";

export type PeopleLookup = ReadonlyMap<string, HistoryPerson>;

export const indexPeople = (history: LeagueHistory): PeopleLookup => new Map(history.people.map((p) => [p.id, p]));

/** A manager's name, falling back to the raw id for someone the history doesn't list. */
export const personName = (people: PeopleLookup, id: string): string => people.get(id)?.name ?? id;

export const profilePath = (personId: string) => `/managers/${personId}`;

/** A manager's name, linking to their profile. */
export function ManagerLink({ personId, people }: { personId: string; people: PeopleLookup }) {
  return (
    <AppLink href={profilePath(personId)} className="manager-link">
      {personName(people, personId)}
    </AppLink>
  );
}
